var $ = require('jquery');

if ( $('.page-section--main').children().last().hasClass('has-background') ) {
    $('.site-pre-footer').addClass('no-margin');
}

var eventAttached = false;
$(window).on('resize', function() {
    setupListeners();
})

function setupListeners() {
    if ( $(window).width() <= 991 ) {
        if ( !eventAttached ) {
            $('.site-footer #menu-footer-navigation > .menu-item').on('click', toggleMenu);
            eventAttached = true;
        }
    } else {
        eventAttached = false;
        $('.site-footer #menu-footer-navigation > .menu-item').off('click', toggleMenu)
        $('.site-footer #menu-footer-navigation > .menu-item.is-expanded').find('.sub-menu').css('max-height', 0);
        $('.site-footer #menu-footer-navigation > .menu-item.is-expanded').removeClass('is-expanded');
    }
}


function toggleMenu(e) {
    e.stopPropagation();
    let el = e.target;
    $(el).toggleClass('is-expanded');
    let subMenuHeight = $(el).hasClass('is-expanded') ? $(el).find('.sub-menu')[0].scrollHeight : 0;
    $(el).find('.sub-menu').css('max-height', subMenuHeight);

}